import velocity from 'velocity-animate';
import $ from 'jquery';
import { Power1, Power0, Power4, TimelineMax } from "gsap/TweenMax";


export default () => {
    var overlayNav = $('.cd-overlay-nav'),
        overlayContent = $('.cd-overlay-content'),
        navigation = $('.cd-primary-nav'),
        toggleNav = $('.cd-nav-trigger');

    function layerInit() {
        var diameterValue = (Math.sqrt(Math.pow($(window).height(), 2) + Math.pow($(window).width(), 2)) * 2);
        overlayNav.children('span').velocity({
            scaleX: 0,
            scaleY: 0,
            translateZ: 0,
        }, 50).velocity({
            height: diameterValue + 'px',
            width: diameterValue + 'px',
            top: -(diameterValue / 2) + 'px',
            left: -(diameterValue / 2) + 'px',
        }, 0);
        overlayContent.children('span').velocity({
            scaleX: 0,
            scaleY: 0,
            translateZ: 0,
        }, 50).velocity({
            height: diameterValue + 'px',
            width: diameterValue + 'px',
            top: -(diameterValue / 2) + 'px',
            left: -(diameterValue / 2) + 'px',
        }, 0);
    }


    layerInit();

    $(window).on('resize', function () {
        window.requestAnimationFrame(layerInit);
    });

    toggleNav.on('click', function () {

        $('.logo').toggleClass("hidden");

        let tl = new TimelineMax();
        let elements = $(".menu-list ul.menu li");

        if (!toggleNav.hasClass('close-nav')) {
            toggleNav.addClass('close-nav');

            $("body").addClass("menu-opened");

            overlayNav.children('span').velocity({
                translateZ: 0,
                scaleX: 1,
                scaleY: 1,
            }, 500, 'easeInCubic', function () {
                navigation.addClass('fade-in');
            });

            setTimeout(function () {
                tl.staggerFrom(elements, 0.75 * elements.length, { y: 30, autoAlpha: 0, ease: Power4.easeOut }, 0.2);
            }, 200);
        } else {
            toggleNav.removeClass('close-nav');

            setTimeout(function () {
                $("body").removeClass("menu-opened");
            }, 1000)

            overlayContent.children('span').velocity({
                translateZ: 0,
                scaleX: 1,
                scaleY: 1,
            }, 500, 'easeInCubic', function () {
                navigation.removeClass('fade-in');
                overlayNav.children('span').velocity({ translateZ: 0, scaleX: 0, scaleY: 0, }, 0);
                overlayContent.addClass('is-hidden').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function () {
                    overlayContent.children('span').velocity({ translateZ: 0, scaleX: 0, scaleY: 0, }, 0, function () {
                        overlayContent.removeClass('is-hidden')
                    });
                });

                if ($('html').hasClass('no-csstransitions')) {
                    overlayContent.children('span').velocity({ translateZ: 0, scaleX: 0, scaleY: 0, }, 0, function () {
                        overlayContent.removeClass('is-hidden')
                    });
                }
            });
        }
    });

    var limit = 20;

    $(window).scroll(function () {
        var st = $(this).scrollTop();

        if (st > limit) {
            $('body').addClass('menu-collapsed');
        } else {
            $('body').removeClass('menu-collapsed');
        }
    })

    // Animazioni nel menu
};



// WEBPACK FOOTER //
// ./scripts/libs/hamburger.js